import {
  SelectInput,
  SelectInputProps,
} from "@/lib/Components/Form/Inputs/SelectInput";
import { BookingChargeType } from "@/gql/graphql";
export function BookingChargeTypeInput(
  props: Omit<SelectInputProps<any>, "options">,
) {
  return (
    <SelectInput
      options={[
        {
          label: "Charge",
          options: [
            {
              label: "Booking Fee",
              value: BookingChargeType.BookingFee,
            },
            {
              label: "Relocation Rate",
              value: BookingChargeType.RelocationRate,
            },
            {
              label: "Daily Rate",
              value: BookingChargeType.DailyRate,
            },
            {
              label: "Platform Held Deposit",
              value: BookingChargeType.PlatformHeldDeposit,
            },
            {
              label: "Supplier Refunded Deposit",
              value: BookingChargeType.SupplierRefundDeposit,
            },
            {
              label: "Additional Charge",
              value: BookingChargeType.AdditionalCharge,
            },
            {
              label: "Purchasable Extra",
              value: BookingChargeType.PurchasableExtra,
            },
          ],
        },
      ]}
      {...props}
    />
  );
}
